<template>
  <!-- <nav
    id="header"
    class="header navbar-default fixed shadow-2xl navbar navbar-expand-lg"
  >
    <div class="navbar-header">
      <router-link to="/" class="navbar-brand">
        <img
          src="https://jktgateway.kpkt.gov.my/images/logo2.jpeg?56f8777aa87d071f4cf0692e7085676f"
          class="h-6 md:h-8 w-auto"
          alt=""
        />

        <!-- <span class="mx-3"> <b>JKT</b> GATEWAY</span> --
      </router-link>

      <!-- <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileSidebar"
          v-if="!pageOptions.pageWithoutSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button> --
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" href="#"
            >Home <span class="sr-only">(current)</span></a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Pricing</a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            Dropdown link
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something else here</a>
          </div>
        </li>
      </ul>
    </div>
    <!-- <button
        @click="login"
        type="button"
        class="navbar-nav navbar-right px-3 text-center align-items-center text-base"
      >
        Login
      </button> --
  </nav> -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top sticky-top">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarTogglerDemo03"
      aria-controls="navbarTogglerDemo03"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <router-link to="/" class="navbar-brand">
      <img
        src="https://jktgateway.kpkt.gov.my/images/logo2.jpeg?56f8777aa87d071f4cf0692e7085676f"
        class="h-6 md:h-8 w-auto"
        alt=""
      />
    </router-link>

    <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
      <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
        <li class="nav-item text-base">
          <a class="nav-link" href="#osc">OSC 3.0</a>
        </li>
        <li class="nav-item text-base">
          <a class="nav-link" href="#iTegur">i-Tegur</a>
        </li>

        <li class="nav-item text-base">
          <a href="#AhliMajlisPBT" class="nav-link">Ahli Majlis PBT</a>
          <!-- <router-link to="#AhliMajlisPBT" class="nav-link"
            >Ahli Majlis PBT</router-link
          > -->
        </li>
        <li class="nav-item text-base">
          <a href="#PasarPBT" class="nav-link">Pasar PBT</a>
        </li>
        <li class="nav-item text-base">
          <a href="#cctv" class="nav-link">CCTV</a>
        </li>
      </ul>
      <button
        @click="login"
        type="button"
        class="text-center align-items-center text-base text-white"
      >
        Login
      </button>
      <form class="form-inline my-2 my-lg-0">
        <!-- <input
          class="form-control mr-sm-2"
          type="search"
          placeholder="Search"
          aria-label="Search"
        />
        <button class="btn btn-outline-success my-2 my-sm-0" type="submit">
          Search
        </button> -->
      </form>
    </div>
  </nav>
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import HeaderMegaMenu from "./HeaderMegaMenu.vue";

export default {
  name: "Header",
  components: {
    HeaderMegaMenu,
  },
  data() {
    return {
      pageOptions: PageOptions,
    };
  },
  methods: {
    login() {
      this.$router.push({ name: "login" });
    },

    handleScroll() {
      const scrollPosition = window.scrollY;
      const panels = document.querySelectorAll("panel");

      panels.forEach((panel) => {
        const panelTop = panel.offsetTop - 50; // Adjust 50 based on your design
        const panelId = panel.getAttribute("id");
        const navLinks = document.querySelectorAll(".navbar-nav .nav-link");

        if (scrollPosition >= panelTop) {
          navLinks.forEach((link) => {
            link.classList.remove("active");
            if (link.getAttribute("href") === `#${panelId}`) {
              link.classList.add("active");
            }
          });
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.nav-link.active {
  color: #ff0000; /* Change color based on your design */
  font-weight: bold; /* Optional: Make the active link bold */
}
</style>
